<template>
  <DealList module="sales" />
</template>

<script>
import DealList from "@/components/deals/DealList.vue";

export default {
  name: "SalesDeal",
  components: {
    DealList
  }
};
</script>
